import { apiClient } from './client'

export async function login(username: string, password: string): Promise<string> {
  const r = await apiClient.post('/api/auth/token/', { username, password })
  localStorage.setItem('pexitalk-jwt', r.data.access)
  localStorage.setItem('pexitalk-refresh', r.data.refresh)
  return r.data.access
}

export function logout(): void {
  // Déconnexion MANUELLE : on révoque la session côté serveur (best-effort,
  // sans bloquer l'UI). C'est indispensable car les tokens ne s'expirent plus
  // tout seuls — sans cette révocation, un token « déconnecté » resterait
  // valide. La requête part AVANT de purger le localStorage (token encore là).
  apiClient.post('/api/auth/logout/').catch(() => { /* best-effort */ })
  localStorage.removeItem('pexitalk-jwt')
  localStorage.removeItem('pexitalk-refresh')
}

/** Demande un email de réinitialisation. Réponse uniforme côté backend
 *  (anti-énumération) — le retour 200 ne garantit pas que l'email existe. */
export async function requestPasswordReset(email: string): Promise<void> {
  await apiClient.post('/api/pexitalk/accounts/password/reset/', { email })
}

/** Confirme le reset avec uid + token reçus par email. */
export async function confirmPasswordReset(
  uid: string,
  token: string,
  newPassword: string,
): Promise<void> {
  await apiClient.post('/api/pexitalk/accounts/password/reset/confirm/', {
    uid,
    token,
    new_password: newPassword,
  })
}
